import '@beyondtrust/btux-iconography-web';
import '@beyondtrust/platform-profile-card';
import { localized, msg } from '@lit/localize';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createRef, Ref, ref } from 'lit/directives/ref.js';
import styles from './user-profile.styles.scss';

export const USER_PROFILE_TAG = 'platform-user-profile' as const;

/**
 * Button and associated dialog containing the user profile
 * information and providing links to manage profile
 * and logout.
 */
@localized()
@customElement(USER_PROFILE_TAG)
export class UserProfile extends LitElement {
  static override styles = [styles];

  dialogRef: Ref<HTMLDialogElement> = createRef();

  private handleClick(evt: Event) {
    if (evt.target === this.dialogRef.value) {
      this.dialogRef.value?.close();
    }
  }

  private toggle() {
    this.dialogRef.value?.showModal();
  }

  override render() {
    return html`
      <button type="button" aria-expanded="true" @click=${this.toggle} aria-label="${msg('User Profile')}">
        <btux-svg name="circle-person"></btux-svg>
      </button>

      <dialog ${ref(this.dialogRef)} @click=${this.handleClick}>
        <user-profile-card show="true"></user-profile-card>
      </dialog>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [USER_PROFILE_TAG]: UserProfile;
  }
}
